module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-sidenav-container"
  }, [(!_vm.IsLoginPage) ? _c('md-toolbar', {
    staticClass: "admin-toolbar",
    style: ([_vm.ContentMargin])
  }, [_c('div', {
    staticClass: "md-toolbar-container top-fixed-bar"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5",
      "md-flex-small": "15"
    }
  }, [(!_vm.IsLoginPage && _vm.hideSideBar == true) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', {
    staticClass: "md-size-1x",
    staticStyle: {
      "color": "#002b49"
    }
  }, [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), (!_vm.IsLoginPage && _vm.hideSideBar == false) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav1
    }
  }, [_c('md-icon', {
    staticClass: "md-size-1x",
    staticStyle: {
      "color": "#002b49"
    }
  }, [_vm._v("menu")])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.toggleSearch()
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("search")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ml-auto row mr-4"
  }, [_c('div', {
    staticClass: "col-4 colSetPad",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "offset": "-65",
      "variant": "link",
      "id": "kk",
      "name": "jhj",
      "size": "lg",
      "no-caret": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('md-icon', {
    staticClass: "md-size-1x nav-icon",
    style: (_vm.unseenNotificationList.length > 0 ? 'color: orange' : '')
  }, [_vm._v("notifications_none")]), _vm._v(" "), (_vm.unseenNotificationList.length > 0) ? _c('b-badge', {
    staticStyle: {
      "min-width": "10px !important",
      "max-width": "34px !important",
      "margin-left": "-20px",
      "top": "-12px !important",
      "font-size": "66% !important"
    },
    attrs: {
      "pill": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.unseenNotificationList.length))]) : _vm._e()], 1), _vm._v(" "), _c('b-dropdown-text', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.unseenNotificationList.length > 0 ?
    "task notifications" :
    "no new notification") + "\n              "), (_vm.unseenNotificationList.length > 0) ? _c('b-badge', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "pill": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.gotoDo
    }
  }, [_vm._v("view all")]) : _vm._e()], 1), _vm._v(" "), (_vm.unseenNotificationList.length > 0) ? _c('b-dropdown-divider') : _vm._e(), _vm._v(" "), _vm._l((_vm.unseenNotificationList), function(item55, index) {
    return _c('b-dropdown-item-button', {
      key: index
    }, [_c('span', {
      staticClass: "text-muted",
      staticStyle: {
        "text-size": "2px",
        "text-align": "left"
      }
    }, [_vm._v("Task Title : " + _vm._s(item55.taskTitle))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-8 colSetPad user-name-box"
  }, [_c('b-dropdown', {
    attrs: {
      "id": "ksdk",
      "name": "jhdsdsj",
      "offset": "-65",
      "variant": "link",
      "size": "lg",
      "no-caret": ""
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('div', {
    staticClass: "user-admin-name"
  }, [_vm._v("\n                " + _vm._s(_vm.UserName) + "\n                "), _c('span', {
    staticClass: "user-destination-name"
  }, [_vm._v(" " + _vm._s(_vm.Designation))])]), _vm._v(" "), _c('md-icon', {
    staticClass: "md-size-1x nav-icon"
  }, [_vm._v("person_outline")])], 1), _vm._v(" "), (_vm.Designation != 'Client') ? _c('b-dropdown-item-button', {
    on: {
      "click": _vm.userProfile
    }
  }, [_c('i', {
    staticClass: "la la-user"
  }), _vm._v("My Profile\n            ")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "la la-sign-out"
  }), _vm._v(" Log Out\n            ")])], 2)], 1)])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.IsLoginPage) ? _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "onHover",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-small",
    staticStyle: {
      "background": "#002b49"
    }
  }, [(_vm.hideSideBar == false) ? _c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('img', {
    staticStyle: {
      "width": "148px",
      "height": "33px",
      "margin-left": "45px"
    },
    attrs: {
      "src": "/assets/logopridelloginpage.png"
    }
  })]) : _c('div', [_c('p', {
    staticStyle: {
      "color": "white",
      "margin-top": "25px"
    }
  }, [_vm._v("Pridel")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "sidenavHalf"
  }, [_c('md-list', _vm._l((_vm.Items), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "left-nav-button",
      staticStyle: {
        "padding": "0px"
      }
    }, [(_vm.checkPermission(item.departmentName, item.finalPagePermision)) ? _c('md-list-item', {
      style: (_vm.CurrentPath == item.path ?
        'background: linear-gradient(180deg, rgb(0 43 73 / 88%), rgb(21 69 116 / 82%)) !important;margin: 0.5rem 2px; border-radius: 4px;box-shadow: 0 0 10px 1px rgb(0 43 73 / 70%);color:#fff !important;' :
        _vm.style.unselected),
      on: {
        "click": function (e) { return _vm.clickRoute(e, item); }
      }
    }, [(item.meta.icon) ? _c('md-icon', {
      staticClass: "md-size-1x",
      style: (_vm.CurrentPath == item.path ?
        'color: #fff' :
        _vm.unseenNotificationList.length > 0 && item.name == 'To Do List' ?
        'color:yellow' :
        'color:#625f6e;' ?
        '' :
        _vm.unseenNotificationList.length > 0 && item.name == 'To Do List' ?
        'color:yellow' :
        'color:#625f6e;opacity:0.7')
    }, [_vm._v(_vm._s(item.meta.icon))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.children) ? _c('md-list-expand', _vm._l((item.children), function(subItem, subIndex) {
      return _c('ul', {
        key: subIndex,
        staticStyle: {
          "padding": "0px"
        }
      }, [(_vm.checkPermissionChild(subItem.finalPagePermision)) ? _c('md-list', {
        staticClass: "left-nav-button"
      }, [((_vm.style = 'width:250px')) ? _c('md-list-item', {
        staticClass: "md-inset",
        style: (_vm.CurrentPath == subItem.path ?
          'background: linear-gradient(180deg, rgb(0 43 73 / 88%), rgb(21 69 116 / 82%)) !important;box-shadow: 0 0 10px 1px rgb(0 43 73 / 70%);margin: 0.5rem 2px; border-radius: 4px;color:#ffffff !important;' :
          'background:#fff !important;'),
        on: {
          "click": function (e) { return _vm.clickRoute(e, subItem); }
        }
      }, [(subItem.meta.icon) ? _c('md-icon', {
        style: (_vm.CurrentPath == subItem.path ? 'color:#fff' : _vm.style.unselected)
      }, [_vm._v(_vm._s(subItem.meta.icon))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(subItem.name))])], 1) : _vm._e()], 1) : _vm._e()], 1)
    })) : _vm._e()], 1) : _vm._e()], 1)
  }))], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.globalSearch) ? _c('section', {
    staticClass: "section-global-search"
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "typeBox",
    attrs: {
      "type": "search",
      "placeholder": "Search ",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.nextItem($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.nextItem($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.nextItem($event)
      }, function($event) {
        _vm.onSearchComponents()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.searchText && _vm.searchText.length > 0) ? _c('div', {
    staticClass: "py-2 border-top border-muted"
  }, [_c('ul', {
    staticClass: "list-unstyled mb-0 px-2 spot-light-search"
  }, _vm._l((_vm.SideNav), function(ChildNav, _index) {
    return (_vm.SideNav && _vm.SideNav.length > 0) ? _c('li', {
      key: _index
    }, [_c('router-link', {
      class: {
        'is-active': _index === _vm.arrowCounter
      },
      attrs: {
        "to": ChildNav.url
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggleSearch()
        }
      }
    }, [_vm._v(_vm._s(ChildNav.name) + "\n                ")])], 1) : _vm._e()
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "close-backdrop",
    on: {
      "click": function($event) {
        _vm.toggleSearch()
      }
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-739517dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/sideBar.vue
// module id = 2747
// module chunks = 0